import { render, staticRenderFns } from "./RequisitosView.vue?vue&type=template&id=6b7eddf0&scoped=true&"
import script from "./RequisitosView.vue?vue&type=script&lang=ts&"
export * from "./RequisitosView.vue?vue&type=script&lang=ts&"
import style0 from "./RequisitosView.vue?vue&type=style&index=0&id=6b7eddf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7eddf0",
  null
  
)

export default component.exports